import store from '@/store'
import { get } from 'lodash'
import {
  PATH_NAME_COIN, PATH_NAME_CUSTOMER_AGREEMENT_HTML_REDIRECT,
  PATH_NAME_CUSTOMER_AGREEMENT_REDIRECT,
  PATH_NAME_CUSTOMER_EVENT_BOARD_LIST,
  PATH_NAME_CUSTOMER_EVENT_BOARD_VIEW_FOR_APP, PATH_NAME_CUSTOMER_EVENT_BOARD_VIEW_REDIRECT,
  PATH_NAME_CUSTOMER_EVENT_LIST,
  PATH_NAME_CUSTOMER_EVENT_VIEW_FOR_APP,
  PATH_NAME_CUSTOMER_EVENT_VIEW_REDIRECT,
  PATH_NAME_CUSTOMER_NOTICE_VIEW_FOR_APP,
  PATH_NAME_EVENT_LIST, PATH_NAME_EVENT_LIST_DEEP_LINK,
  PATH_NAME_INDEX_REDIRECT,
  PATH_NAME_LIVE_PLAYER_REDIRECT,
  PATH_NAME_LNB_USER_INFO,
  PATH_NAME_LOGIN_REDIRECT,
  PATH_NAME_LOGIN_REDIRECT_HTML,
  PATH_NAME_MOVIE_PLAYER_REDIRECT, PATH_NAME_MYPOOQ_INDEX_REDIRECT, PATH_NAME_MYPOOQ_REDIRECT,
  PATH_NAME_PAID,
  PATH_NAME_POOQZONE_VOUCHER,
  PATH_NAME_POOQZONE_PRIVACY,
  PATH_NAME_PRIVACY,
  PATH_NAME_PROFILE,
  PATH_NAME_REGIST,
  PATH_NAME_SEARCH,
  PATH_NAME_SEARCH_REDIRECT,
  PATH_NAME_SERVICE,
  PATH_NAME_TEMP_SUBSCRIPTION_COIN_FOR_ANDROID,
  PATH_NAME_VOD_PLAYER_REDIRECT,
  PATH_NAME_VOUCHER_ALL_FOR_ANDROID,
  PATH_NAME_VOUCHER_ALL_FOR_IOS,
  PATH_NAME_VOUCHER_ALL_FOR_IOS_201802,
  PATH_NAME_VOUCHER_INDEX,
  PATH_NAME_VOUCHER_PARTNER_FOR_ANDROID,
  PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP,
  PATH_NAME_VOUCHER_RECOMMEND_ANDROID,
  PATH_NAME_VOUCHER_RECOMMEND_FOR_IOS,
  PATH_NAME_VOUCHER_RECOMMEND_FOR_IOS_201802,
  PATH_NAME_VOUCHER_REGIST_FOR_ANDROID, PATH_NAME_WAVVEON_INTRO,
  PATH_NAME_YOUTH, PATH_NAME_WAVVE_LINK_CUSTOMER_NOTICE_VIEW, PATH_NAME_WAVVE_LINK_EVENT_VIEW
} from '@/common/router.const'
import { agreementRedirect } from '@/common/util/router.utils'

export default [
  {
    path: '/index',
    name: PATH_NAME_INDEX_REDIRECT,
    redirect: to => '/'
  },
  {
    path: '/member/login.html',
    name: PATH_NAME_LOGIN_REDIRECT_HTML,
    redirect: to => {
      return '/login'
    }
  },
  {
    path: '/member/login',
    name: PATH_NAME_LOGIN_REDIRECT,
    redirect: to => {
      return '/login'
    }
  },
  {
    path: '/member/profile.html',
    name: PATH_NAME_PROFILE,
    redirect: { name: PATH_NAME_LNB_USER_INFO }
  },
  {
    path: '/customer/notice_view.html',
    name: PATH_NAME_CUSTOMER_NOTICE_VIEW_FOR_APP,
    redirect: to => {
      return `/customer/notice_view/${to.query.noticeId}`
    }
  },
  {
    path: '/search/search',
    name: PATH_NAME_SEARCH_REDIRECT,
    redirect: { name: PATH_NAME_SEARCH }
  },
  {
    path: '/player/movie.html',
    name: PATH_NAME_MOVIE_PLAYER_REDIRECT,
    redirect: (to) => {
      return `/player/movie`
    }
  },
  {
    path: '/player/vod.html',
    name: PATH_NAME_VOD_PLAYER_REDIRECT,
    redirect: (to) => {
      return `/player/vod`
    }
  },
  {
    path: '/player/live.html',
    name: PATH_NAME_LIVE_PLAYER_REDIRECT,
    redirect: (to) => {
      return `/player/live`
    }
  },
  { // TODO: 임시용 안드로이드에서 마이페이지 네이티브 메뉴 정리되면 가이 삭제 요망
    path: '/mypooq/subscription_coin.html',
    name: PATH_NAME_TEMP_SUBSCRIPTION_COIN_FOR_ANDROID,
    redirect: { name: PATH_NAME_COIN }
  },
  {
    path: '/voucher/all',
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/recommend',
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/index_ios.html',
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/popup_new_ios.html',
    redirect: { name: PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP }
  },
  {
    path: '/voucher/recommend_ios_201802.html',
    name: PATH_NAME_VOUCHER_RECOMMEND_FOR_IOS_201802,
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/recommend_ios_201909.html',
    name: PATH_NAME_VOUCHER_RECOMMEND_FOR_IOS,
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/recommend.html',
    name: PATH_NAME_VOUCHER_RECOMMEND_ANDROID,
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/index_ios_201802.html',
    name: PATH_NAME_VOUCHER_ALL_FOR_IOS_201802,
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/index_ios_201909.html',
    name: PATH_NAME_VOUCHER_ALL_FOR_IOS,
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/index.html',
    name: PATH_NAME_VOUCHER_ALL_FOR_ANDROID,
    redirect: { name: PATH_NAME_VOUCHER_INDEX }
  },
  {
    path: '/voucher/partner.html',
    name: PATH_NAME_VOUCHER_PARTNER_FOR_ANDROID,
    redirect: { name: 'partner' }
  },
  {
    path: '/voucher/regist.html',
    name: PATH_NAME_VOUCHER_REGIST_FOR_ANDROID,
    redirect: { name: PATH_NAME_REGIST }
  },
  {
    path: '/voucher/pooqzone',
    redirect: '/voucher/wavveon'
  },
  {
    path: '/voucher/pooqzone.html',
    redirect: '/voucher/wavveon'
  },
  // {
  //   path: '/voucher/pooqzone.html',
  //   name: 'voucher_pooqzone_for_android',
  //   redirect: (to, from, next) => {
  //     next({ name: 'pooqzone' })
  //   }
  // },
  {
    path: '/pooqzone.html',
    redirect: { name: PATH_NAME_WAVVEON_INTRO }
  },
  {
    path: '/customer/agreement',
    name: PATH_NAME_CUSTOMER_AGREEMENT_REDIRECT,
    redirect: agreementRedirect
  },
  {
    path: '/customer/agreement.html',
    name: PATH_NAME_CUSTOMER_AGREEMENT_HTML_REDIRECT,
    redirect: agreementRedirect
  },
  {
    path: '/customer/event_list',
    name: PATH_NAME_CUSTOMER_EVENT_LIST,
    redirect: () => {
      return `/event/list`
    }
  },
  {
    path: '/customer/event_view.html',
    name: PATH_NAME_CUSTOMER_EVENT_VIEW_FOR_APP,
    redirect: (to) => {
      return `/event/detail/${to.query.eventId}`
    }
  },
  {
    path: '/customer/event_view',
    name: PATH_NAME_CUSTOMER_EVENT_VIEW_REDIRECT,
    redirect: (to) => {
      return `/event/detail/${to.query.eventId}`
    }
  },
  {
    path: '/customer/event_board_list',
    name: PATH_NAME_CUSTOMER_EVENT_BOARD_LIST,
    redirect: () => {
      return `/event/board`
    }
  },
  {
    path: '/customer/event_board_view.html',
    name: PATH_NAME_CUSTOMER_EVENT_BOARD_VIEW_FOR_APP,
    redirect: (to) => {
      return `/event/board/${to.query.eventId}`
    }
  },
  {
    path: '/customer/event_board_view',
    name: PATH_NAME_CUSTOMER_EVENT_BOARD_VIEW_REDIRECT,
    redirect: (to) => {
      return `/event/board/${to.query.eventId}`
    }
  },
  {
    path: '/customer/event_list',
    name: PATH_NAME_EVENT_LIST_DEEP_LINK,
    redirect: { name: PATH_NAME_EVENT_LIST }
  },
  {
    path: '/customer/notice_view',
    name: PATH_NAME_WAVVE_LINK_CUSTOMER_NOTICE_VIEW,
    redirect: (to) => {
      return `/customer/notice_view/${to.query.noticeId}`
    }
  },
  {
    path: '/customer/event_view',
    namd: PATH_NAME_WAVVE_LINK_EVENT_VIEW,
    redirect: (to) => {
      return `/event/detail/${to.query.eventId}`
    }
  },
  // {
  //   path: '/customer/agreement.html',
  //   name: PATH_NAME_CUSTOMER_AGREEMENT_HTML_REDIRECT,
  //   beforeEnter (to, from, next) {
  //     const category = get(to, ['query', 'category'], '')
  //     let pathName = category
  //     if(category === 'pooqzone') {
  //       pathName = PATH_NAME_POOQZONE_VOUCHER
  //     }
  //     next({ name: category === '' ? 'service' : category })
  //   }
  // },
  {
    path: '/mypooq',
    name: PATH_NAME_MYPOOQ_INDEX_REDIRECT,
    beforeEnter (to, from, next) {
      const pathList = to.fullPath.split('/')
      pathList[1] = 'my'
      next(pathList.join('/'))
    }
  },
  {
    path: '/mypooq/:path',
    name: PATH_NAME_MYPOOQ_REDIRECT,
    beforeEnter (to, from, next) {
      const pathList = to.fullPath.split('/')
      pathList[1] = 'my'
      next(pathList.join('/'))
    }
  },
  {
    path: '/bifan',
    name: 'PATH_BIFAN_REDIRECT',
    redirect: () => {
      return '/supermultisection/GN803'
    }
  }
]
